module.exports = __webpack_public_path__ + "static/media/og-awair.2d8ffd28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/seo/og-awair.jpg
// module id = 404
// module chunks = 0